<template lang="html">

  <ul class="redes-cat flex row justify-start">
    <li><a href="https://www.linkedin.com/company/ajusa" class="fa fa-linkedin" target="_blank"></a></li>
    <li><a href="https://www.facebook.com/AjusaSpain/" target="_blank"><i class="fa fa-facebook"></i></a></li>
    <li><a target="_blank" :href="'https://twitter.com/ajusa_spain?lang='+getLanguage"><i class="fa-brands fa-x-twitter"></i></a></li>
    <li><a class="fa fa-instagram" href="https://www.instagram.com/ajusa_automotive/" target="_blank"></a></li>
</ul> 


</template>

<script lang="js">

  import {mapGetters} from 'vuex'

  export default  {
    name: 'rrss-share',
    props: ['texto','data'],
    mounted() {
        let to = this.$route.params.id;

        // var img;

        // if(!!to){

        //     for(let i in this.getTexts.productos.shared){

        //         if(this.getTexts.productos.shared[i] == to){
        //             img = i;
        //         }
        //     }

        // }

        document.head.querySelector("[property='og:title']").content = this.textos[to];
        if(!!to){
            document.head.querySelector("[property='og:image']").content = location.origin+'/static/shared/img/'+this.images[to]+'.jpg';
        }
        document.head.querySelector("[property='og:url']").content = location.href;
        document.head.querySelector("[property='og:description']").content = this.$route.meta.description;
        window.prerenderReady = true;
    },
    data() {
      return {
        textos : {
            'junta-turbo' : 'Juegos de juntas para turbo Ajusa',
            'ajusil' : 'Sellante de silicona Ajusa',
            'nuevo_sellante' : 'Sellante Anaeróbico',
            'arbol-levas' : 'Árboles de levas Ajusa',
            'junta-culata' : 'Juntas de culata Ajusa',
            'junta-motor' : 'Juegos de juntas para el motor Ajusa',
            'otros' : 'Válvulas EGR Ajusa',
            'retenes' : 'Retenes Ajusa',
            'taques' : 'Taqués hidráulicos Ajusa',
            'tornillos' : 'Tornillos de culata Ajusa',
            'tubos-engrase' : 'Tubos de engrase para turbos Ajusa',
          

            'ajusil-en' : 'Silicone sealant Ajusa',
            'anaerobic-sealant' : 'Anaerobic Sealant Ajustick ',
            'turbo-fitting' : 'Turbo fitting Ajusa',
            'camshafts' : 'Camshafts Ajusa',
            'cylinder-head' : 'Cylinder Head Gaskets Ajusa',
            'full-gasket-sets' : 'Full Gaskets set Ajusa',
            'others' : 'Other components Ajusa',
            'oils-seals' : 'Oil seals Ajusa',
            'hydraulic-lifers' : 'Hydraulic lifters Ajusa',
            'cylinder-head-bolts' : 'Cylinder Head Bolts Ajusa',
            'oil-feed-pipes' : 'Oil feed pipes Ajusa',

            'ajusil-br' : 'COLA DE SILICONE Ajusa',
            'vedante-anaerobico-ajustic' : 'Vedante anaeróbico Ajustick',
            'montagem-de-turbo' : 'Juegos de juntas para turbo Ajusa',
            'comandos-de-valvulas' : 'COMANDOS DE VÁLVULAS Ajusa',
            'juntas-de-cabecote' : 'Juntas de cabeçote Ajusa',
            'jogos-de-juntas-completos' : 'JOGOS DE JUNTAS Ajusa',
            'outros' : 'OUTROS COMPONENTES Ajusa',
            'retentores-de-oleo' : 'RETENTORES DE ÓLEO Ajusa',
            'tuchos-hidraulicos' : 'TUCHOS HIDRÁULICOS Ajusa',
            'parafusos-de-cabecote' : 'PARAFUSOS DE CABEÇOTE Ajusa',
            'tubos-de-lubrificacao-de-turbina' : 'TUBO DE LUBRIFICAÇÃO DA TURBINA Ajusa',
            'kits-de-juntas-da-turbina' : 'KITS DE JUNTAS DA TURBINA Ajusa',


            'турбо-фитинг' : 'КОМПЛЕКТЫ ТУРБО-ФИТИНГОВ Ajusa',
            'ajusil-ru' : 'СИЛИКОНОВЫЙ ГЕРМЕТИК Ajusa',
            'aнаэробный-герметик-ajustick' : 'Анаэробный герметик Ajustick',
            'распределительные-валы' : 'РАСПРЕДЕЛИТЕЛЬНЫЕ ВАЛЫ Ajusa',
            'головка-блока-цилиндров' : 'прокладки головки блока цилиндров Ajusa',
            'полные-комплекты-прокладок' : 'ПОЛНЫЕ КОМПЛЕКТЫ ПРОКЛАДОК Ajusa',
            'другие' : 'ДРУГИЕ КОМПОНЕНТЫ Ajusa',
            'сальники' : 'САЛЬНИКИ Ajusa',
            'гидрокомпенсаторы' : 'ГИДРОКОМПЕНСАТОРЫ Ajusa',
            'болты-головки-блока-цилиндров' : 'БОЛТЫ ГОЛОВКИ БЛОКА ЦИЛИНДРОВ Ajusa',
            'трубки-подачи-масла' : 'ТРУБКИ ПОДАЧИ МАСЛА Ajusa',
        },
        images : {

            'junta-turbo' : "junta-turbo",
            'ajusil' : "ajusil",
            'arbol-levas' : "arbol-levas",
            'junta-culata' : "junta-culata",
            'junta-motor' : "junta-motor",
            'otros' : "otros",
            'retenes' : "retenes",
            'taques' : "taques",
            'tornillos' : "tornillos",
            'tubos-engrase' : "tubos-engrase",
            'nuevo_sellante' : 'nuevo_sellante',
            'vedante-anaerobico-ajustic' : 'nuevo_sellante',
            
            "turbo-fitting" :'junta-turbo',
            "ajusil-en" :'ajusil',
            "anaerobic-sealant" :'nuevo_sellante',
            "camshafts" :'arbol-levas',
            "cylinder-head" :'junta-culata',
            "full-gasket-sets" :'junta-motor',
            "others" :'otros',
            "oils-seals" :'retenes',
            "hydraulic-lifers" :'taques',
            "cylinder-head-bolts" :'tornillos',
            "oil-feed-pipes" :'tubos-engrase',

            "montagem-de-turbo" :'junta-turbo',
            "ajusil-br" :'ajusil',
            "nuevo_sellante_br": 'nuevo_sellante',
            "comandos-de-valvulas" :'arbol-levas',
            "juntas-de-cabecote" :'junta-culata',
            "jogos-de-juntas-completos" :'junta-motor',
            "outros" :'otros',
            "retentores-de-oleo" :'retenes',
            "tuchos-hidraulicos" :'taques',
            "parafusos-de-cabecote" :'tornillos',
            "tubos-de-lubrificacao-de-turbina" :'tubos-engrase',

            "турбо-фитинг": 'junta-turbo',
            "ajusil-ru": 'ajusil',
            "nuevo_sellante_ru" : 'nuevo_sellante',
            "распределительные-валы": 'arbol-levas',
            "головка-блока-цилиндров": 'junta-culata',
            "полные-комплекты-прокладок": 'junta-motor',
            "другие": 'otros',
            "сальники": 'retenes',
            "гидрокомпенсаторы": 'taques',
            "болты-головки-блока-цилиндров": 'tornillos',
             'aнаэробный-герметик-ajustick' : 'nuevo_sellante',
            "трубки-подачи-масла": 'tubos-engrase'
        }
    }
},
methods: {

},
computed : {
  ...mapGetters(['getLanguage', 'getTexts']),
  url : function (){
    let url = location.href.replace(this.$route.params.id, '');
    return url+"/"+this.data;
}
}
}
</script>

<style scoped>
.rrss-share {

}
</style>



// WEBPACK FOOTER //
// src/components/parts/rrss-share.vue